// @ts-ignore
export default async function guest({ next }) {
  return next();
}
